import { Banner, Page } from '@shopify/polaris'
import React from 'react'

import { useShopFlag } from './helpers'

/**
 * Shown when the backend marked the shop as needing re-authentication (its Shopify access
 * token no longer works). The merchant is redirected to OAuth automatically on the first
 * visit; this banner covers every visit after that so they can always trigger it themselves.
 */
export const ReauthBanner = () => {
  const reauthRequired = useShopFlag('reauth_required')
  const reauthUrl = useShopFlag('reauth_url')

  if (!reauthRequired || !reauthUrl) {
    return null
  }

  return (
    <Page>
      <Banner
        tone="critical"
        title="Reconnect your store"
        action={{
          content: 'Reconnect now',
          onAction: () => window.open(reauthUrl, '_top'),
        }}
      >
        <p>
          The app's connection to your store has expired. Subscriptions can't be billed and store
          data can't be synced until you re-authorize the app in Shopify. Your plan, settings and
          subscriptions are kept as they are.
        </p>
      </Banner>
    </Page>
  )
}
